import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutDialogComponent } from 'src/components/checkout-dialog/checkout-dialog.component';
import { ChooseAvatarBottomsheetComponent } from 'src/components/choose-avatar-bottomsheet/choose-avatar-bottomsheet.component';
import { WebcamDialogComponent } from 'src/components/webcam-dialog/webcam-dialog.component';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { NotificationService } from 'src/services/notification.service';
import { OneSignalService } from 'src/services/onesignal.service';
import { UploadService } from 'src/services/upload.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-recruiter',
  templateUrl: './recruiter.component.html',
  styleUrls: ['./recruiter.component.scss']
})
export class RecruiterComponent implements OnInit {

  submiting: boolean = false;
  menu: Array<any> = new Array();
  isMobile$: Observable<any>;
  drawerOpen: boolean = false;
  user: any;
  @ViewChild('fileInput', { static: false }) private fileInput: ElementRef;
  @ViewChild('drawer', { static: false }) private drawer: MatSidenav;
  avatarPicture: string = null;
  progressUpload: number;
  adminUser: any;

  constructor(
    private http: HttpService,
    private change: ChangeDetectorRef,
    private breakpoints: BreakpointObserver,
    private upload: UploadService,
    private errorReport: ErrorReportService,
    @Inject('MIDIA_ENDPOINT') private midiaEndpoint: string,
    private bottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private router : Router,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private oneSignalService: OneSignalService
  ) {

    this.isMobile$ = this.breakpoints
      .observe([Breakpoints.Small, Breakpoints.Handset])
      .pipe(map(result => result.matches));

    this.menu = [
      {
        icon: 'how_to_reg',
        label: 'Processos seletivos',
        routerLink: ['list']
      },
      {
        icon: 'description',
        label: 'Testes e Entrevistas',
        routerLink: ['tests']
      },
      {
        icon: 'settings',
        label: 'Meu perfil',
        routerLink: ['account']
      },
      {
        icon: 'supervisor_account',
        label: 'Gerenciar usuários',
        routerLink: ['users']
      },
    ]

  }

  ngOnInit(): void {

    this.http.getGlobalLoadingIndicator()
      .subscribe(
        result => {
          const { trigger } = result;
          this.submiting = trigger === 'pre';
          this.change.detectChanges();
        }
      )

    this.user = JSON.parse(localStorage.getItem('token'));
      
    // console.log('Usuário:',this.user);
    this.getAdminUser();  
    this.getAvatar();

    if (this.user.company_root as Boolean) {

      this.menu.push({
        icon: 'analytics',
        label: 'Relatório',
        routerLink: ['analytics']
      })

      this.menu.push(
        {
          icon: 'work',
          label: 'Gerenciar recrutadores',
          routerLink: ['voucher']
        }
      );

      this.menu.push(
        {
          icon: 'notification_add',
          label: 'Enviar Notificação',
          routerLink: ['notification']
        }
      );

      this.menu.push(
        {
          icon: 'assignment_turned_in',
          label: 'Aprovar recrutadores',
          routerLink: ['approve-recruiters']
        }
      );

    }

    const wObject = (window as any);
    wObject.flutterTriggerEvent = (args) => {

      const { type, data } = args;
      if (type === 'drawer') {
        if (data)
          this.drawer.open();
        else this.drawer.close();
        this.drawerOpen = !this.drawerOpen
      }

    }
    
    // console.log(this.user)

    // if (this.user.signature_status !== 'ACTIVE') {
    var plano = this.user.company_id ? 'BUSINESS' : 'PERSONAL';

    if (this.user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL' && plano == 'BUSINESS') {
      if (!this.router.url.includes('/welcome') && !this.router.url.includes('/payment')) {

        this.notificationService.showAccountActivationMessage();

        // const options = {
        //   disableClose: true,
        //   width: '1000px'
        // }
        // this.dialog.open(CheckoutDialogComponent, options)

      }
    }

    try {
      this.oneSignalService.initOneSignal(); // Aguarde a inicialização
    } catch (error) {
      console.error('Error initializing OneSignal in component:', error);
    }

    setInterval(()=>{
      this.oneSignalService.checkNotificationPermission();
    }, 15000)

    this.oneSignalService.listNotification();

  }

  private getAvatar() {

    this.http.get('profile:avatar', { id: this.user.id }, null, true)
      .subscribe(
        (result: any) => {

          if (result.data.avatar_profile) {
            const uuid = uuidv4();
            this.avatarPicture = `${this.midiaEndpoint}${result.data.avatar_profile}?r=${uuid}`;
          }

        },
        err => this.errorReport.showMessage(err)
      )

  }

  logout() {
    localStorage.clear();
    // localStorage.removeItem('token');
    setTimeout(() => window.location.reload(), 1000);
  }

  openChooseFile() {

    this.bottomSheet.open(ChooseAvatarBottomsheetComponent)
      .afterDismissed()
      .subscribe(
        result => {

          if (result === 'GALLERY')
            this.fileInput.nativeElement.click();
          else if (result === 'CAMERA') {

            const options = {
              width: '550px',
              disableClose: true
            }
            this.dialog.open(WebcamDialogComponent, options)
              .afterClosed()
              .subscribe(
                (result: any) => {

                  if (result) {
                    this.avatarPicture = result.imageAsDataUrl;
                    this.beginUpload(result.imageBytes);
                  }
                }
              )

          }

        }
      )

  }

  changeAvatar(args) {

    const [file] = args.target.files;

    if (!file) return;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      const dataUrl = fileReader.result as string;
      this.avatarPicture = dataUrl;
    }
    fileReader.readAsDataURL(file);
    this.beginUpload(file);

  }

  private beginUpload(file) {

    const params = { id: this.user.id };
    const options = {
      reportProgress: true,
      observe: 'events'
    };

    this.upload.upload('profile:avatar', file, 'avatar', params, options)
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              this.progressUpload = Math.round(event.loaded / event.total * 100);
              break;
            case HttpEventType.Response:
              setTimeout(() => {
                this.progressUpload = 0;
              }, 500);
              break;
          }

        },
        err => this.errorReport.showMessage(err)
      );

  }

  onOpenedChange(opened) {

    const wObject = (window as any);
    if (opened) {
      wObject.setPushEvent({
        type: 'drawer',
        opened
      });
    } else {
      wObject.setPushEvent({
        type: 'url',
        data: null
      });
    }

  }

  getAdminUser(){
    const data = {
      companyId: this.user.company_id
    }
    this.http.list('company:getAdmin', data)
      .subscribe(
        (result:any) => {
          this.adminUser = result.data.companyemail;

          if(this.user.email === this.adminUser){
            this.menu.push({
              //icon: 'admin_panel_settings',
              icon: 'attach_money',
              label: 'Financeiro',
              routerLink: ['finance'],
              // click: () => {

              //   this.drawerOpen = false;

              //   if(this.user.signature_id && this.user.signature_status === 'ACTIVE')
              //     this.router.navigate(['/', 'customer', 'my-account'])
              //   else {
              //     const options = {
              //       disableClose: true,
              //       width: '600px'
              //     }
              //     this.dialog.open(CheckoutDialogComponent, options)
              //   }

              // }
            });
          }


        },
        err => this.errorReport.showMessage(err)
      )

  }

}